<template>
<div class="chapter">
<div class="inner_page">
<p class="txe" id="pz4-1">Deep calls to deep at the roar of your waterfalls; </p>
<p class="txe1" id="pz4-3">all your breakers and your waves have gone over me. </p>
<p class="txr1" id="pz4-5"><i>Psalm 42.7</i> </p>
<p class="txe2" id="pz4-6">the tempest<br/> the darkness<br/> the waves that you sent<br/> just the saltwater taste<br/> of these songs of descent</p>
<p class="txe2" id="pz4-11">still sinking<br/> still losing<br/> the waves won’t relent<br/> I won’t go down quiet<br/> this is a song of dissent.</p>
<p class="txe2" id="pz4-16">no flailing<br/> no swimming<br/> I’m not innocent<br/> water fills my lungs<br/> This is my song of descent.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?da36a1a2